export const convertStringToTitleCase = (str: string): string =>
  str
    .split(/\s+/)
    .filter((word) => word.length !== 0)
    .map((word) => `${word[0].toUpperCase()}${word.slice(1).toLowerCase()}`)
    .join(' ');

export const convertStringToSentenceCase = (str: string): string =>
  `${str[0].toUpperCase()}${str.slice(1).toLowerCase()}`;
